// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { type MutateOptions, useMutation } from '@tanstack/react-query'

import { type Coverage } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type AddCoverageParam = {
  covered_participant_id: string
  start_date: string
  end_date: string
  coverage_audit_reason: string
}

export type CoverageMutateOptions =
  | MutateOptions<Coverage[], GrapeAPIErrorType, AddCoverageParam, unknown>
  | undefined

export function useAddCoverageToEnrollment ({
  enrollmentId,
  memberId,
}: {
  enrollmentId: string
  memberId: string
}) {
  return useMutation<Coverage[], GrapeAPIErrorType, AddCoverageParam>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'post',
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/coverage`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
